var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('RouterView',{key:_vm.$route.fullPath}),_c('BackToTop'),_c('TeamImpersonationModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }